import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { OffboardingClient } from '../shared/models/offboarding/offboarding-client';
import { OffboardingClientListResponse } from '../shared/models/offboarding/offboarding-client-list-response';
import { OffboardingStepChanged } from '../shared/models/offboarding/offboarding-step-changed';
import { OffboardingCategory } from '../shared/models/offboarding/offboarding-category';
import { Note } from '../shared/models/note/note';
import { ClientNotesResponse } from '../shared/models/note/client-notes-response';
import { CreateNoteRequest, NoteType } from '../shared/models/note/create-note-request';

@Injectable({
  providedIn: 'root',
})
export class OffboardingService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/offboarding/';

  constructor(private http: HttpClient) {}

  public GetOffboardingClients(): Observable<OffboardingClientListResponse> {
    return this.http.get<OffboardingClientListResponse>(`${this.apiUrl}clients`);
  }

  public GetOffboardingClientInformation(clientId: number): Observable<OffboardingClient> {
    return this.http.get<OffboardingClient>(`${this.apiUrl}client/${clientId}`);
  }

  public GetAllCategoriesAndSteps(): Observable<OffboardingCategory[]> {
    return this.http.get<OffboardingCategory[]>(`${this.apiUrl}steps`);
  }

  public UpdateStep(clientId: number, stepId: number, complete: boolean, updatedByUserId: number): Observable<OffboardingStepChanged> {
    const changeStepRequest = {
      clientId: clientId,
      stepId: stepId,
      isComplete: complete,
      updatedByUserId: updatedByUserId,
    };
    return this.http.post<OffboardingStepChanged>(`${this.apiUrl}client/update-step`, changeStepRequest);
  }

  public ArchiveClient(clientId: number, actionByUserId: number): Observable<any> {
    const archiveRequest = {
      clientId: clientId,
      actionByUserId: actionByUserId,
    };
    return this.http.post<any>(`${this.apiUrl}client/archive`, archiveRequest);
  }

  public GetOffboardingClientNotes(clientId: number): Observable<ClientNotesResponse> {
    return this.http.get<ClientNotesResponse>(`${this.apiUrl}client/${clientId}/notes`);
  }

  public CreateOffboardingClientNote(clientId: number, createdByUserId: number, note: string): Observable<Note> {
    const createNoteRequest: CreateNoteRequest = {
      clientId: clientId,
      note: note,
      createdByUserId: createdByUserId,
      noteType: NoteType.Admin,
    };
    return this.http.post<Note>(`${this.apiUrl}client/create-note`, createNoteRequest);
  }
}
